import * as React                           from "react";
import {sothebys_canada_buscard_0218}       from "./build-paths/sothebys_canada_buscard_0218";
import {sothebys_gen_tab_buscard}           from "./build-paths/sothebys_gen_tab_buscard";
import {FiveColumnSpecs}                    from "./build-paths/5_column_specs";
import {sothebys_gen_buscard}               from "./build-paths/sothebys_gen_buscard";
import {sothebys_gen_buscard_WP_Nof}        from "./build-paths/sothebys_gen_buscard_WP_Nof";
import {sothebys_gen_buscard_international} from "./build-paths/sothebys_gen_buscard_international";
import {genBuscardV2}                       from "./build-paths/gen_buscard_v2";
import {genBuscard}                       from "./build-paths/gen_buscard";
import {daniel_gale_sothebys_gen_buscard}   from "./build-paths/daniel_gale_sothebys_gen_buscard";
import {generic_bus_card_logo}              from "./build-paths/generic_bus_card_logo";
import {sothebys_brochure_mls_mailable}     from "./build-paths/sothebys_brochure_mls_mailable";
import {norcal_market_update}               from "./build-paths/norcal_market_update";
import {prurealty_bus_cards_no_auto}               from "./build-paths/prurealty_bus_cards_no_auto";


export const BuildPathHandler = ({buildPath, idBranch, session, contentFields, specificationFields, specFieldOnChange, orderData, next}) => {
        switch(buildPath) {
            case "sothebys_canada_buscard_0218.inc":
                return sothebys_canada_buscard_0218({idBranch, session, specificationFields, specFieldOnChange, next});

            case "sothebys_gen_tab_buscard.inc":
                return sothebys_gen_tab_buscard({idBranch, session, specificationFields, specFieldOnChange, next});

            case "sothebys_gen_buscard.inc":
                return sothebys_gen_buscard({idBranch, session, specificationFields, specFieldOnChange, next});

            case "daniel_gale_sothebys_gen_buscard.inc":
                return daniel_gale_sothebys_gen_buscard({idBranch, session, specificationFields, specFieldOnChange, next});

            // leaving this here as reference since it will be done very soon.
            case "gen_buscard_v2.inc":
                return genBuscardV2({session, specificationFields, specFieldOnChange, next});

            case "5_column_specs.inc":
                return FiveColumnSpecs({specificationFields, specFieldOnChange, next});

            case "sothebys_gen_buscard_WP_Nof.inc":
                return sothebys_gen_buscard_WP_Nof({idBranch, session, specificationFields, specFieldOnChange, next});

            case "sothebys_gen_buscard_international.inc":
                return sothebys_gen_buscard_international({idBranch, session, specificationFields, specFieldOnChange, next});

            case "cbfl_gen_buscard_v2.inc":
                return genBuscardV2({session, specificationFields, specFieldOnChange, next});

            case "generic_bus_card_logo.inc":
                return generic_bus_card_logo({session, specificationFields, specFieldOnChange, next});

            case "sothebys_brochure_mls_mailable.inc":
                return sothebys_brochure_mls_mailable({session, specificationFields, specFieldOnChange, next});

            case "norcal_market_update.inc":
                return norcal_market_update({specificationFields, specFieldOnChange, next});    
            
            case "prurealty_bus_cards_no_auto.inc":
                return prurealty_bus_cards_no_auto({session, specificationFields, specFieldOnChange, next}); 
            
            case "headshot_not_required.inc":
            case "chase_bus_cards.inc":
            case "gen_buscard_with_info.inc":
                return genBuscardV2({session, specificationFields, specFieldOnChange, next});
            case "gen_buscard.inc":
            case "pru_americana_buscard_no_des.inc":
            case "gmac_emre_bus_cards_2or1.inc":
                return genBuscard({session, specificationFields, specFieldOnChange, next});    
                            
            default:
                return "no buildpath";
        };
};